/**
 * Główny init dla wszystkich customowych skryptów.
 */
export default function initCustomEngine() {
  initCategoryTreeToggle();
  initCartGoToSummary();
  initPhoneInputs();
  initRegisterCountryStates();
  initSapStock();
  // initSideCart();
}

/**
 * "Pokaż więcej / mniej" dla ps_categorytree
 */
function initCategoryTreeToggle() {
  document.querySelectorAll('.ps_categorytree').forEach((tree) => {
    const toggleBtn = tree.querySelector('.category-tree__toggle');
    if (!toggleBtn) {
      return;
    }

    if (toggleBtn.dataset.customEngineInit === '1') {
      return;
    }
    toggleBtn.dataset.customEngineInit = '1';

    const hiddenItems = tree.querySelectorAll('.category-tree__item--hidden');

    if (!hiddenItems.length) {
      toggleBtn.style.display = 'none';
      return;
    }

    hiddenItems.forEach((li) => {
      li.classList.add('d-none');
    });

    const labelMore = toggleBtn.getAttribute('data-label-more') || 'Show more';
    const labelLess = toggleBtn.getAttribute('data-label-less') || 'Show less';

    // Stan początkowy
    toggleBtn.textContent = labelMore;
    toggleBtn.setAttribute('data-state', 'collapsed');

    toggleBtn.addEventListener('click', () => {
      const isCollapsed = toggleBtn.getAttribute('data-state') === 'collapsed';

      if (isCollapsed) {
        // pokaż ukryte
        hiddenItems.forEach((li) => {
          li.classList.remove('d-none');
        });
        toggleBtn.setAttribute('data-state', 'expanded');
        toggleBtn.textContent = labelLess;
      } else {
        // schowaj ponownie
        hiddenItems.forEach((li) => {
          li.classList.add('d-none');
        });
        toggleBtn.setAttribute('data-state', 'collapsed');
        toggleBtn.textContent = labelMore;
      }
    });
  });
}

/**
 * Przycisk "Idź do podsumowania" w koszyku:
 * - pokazuje się tylko gdy widać główną część koszyka, a nie widać podsumowania
 * - po kliknięciu scrolluje do #buybox
 */
function initCartGoToSummary() {
  const btnWrapper = document.querySelector('.cart-go-to-summary');
  const btn = btnWrapper?.querySelector('.js-go-to-summary');
  const cartMain = document.querySelector('.cart-main');
  const cartSummary = document.querySelector('#buybox');

  if (!btnWrapper || !btn || !cartMain || !cartSummary) return;

  let mainVisible = false;
  let summaryVisible = false;

  const updateVisibility = () => {
    btnWrapper.classList.toggle('is-visible', mainVisible && !summaryVisible);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target === cartMain) {
        mainVisible = entry.isIntersecting;
      } else if (entry.target === cartSummary) {
        summaryVisible = entry.isIntersecting;
      }
    });
    updateVisibility();
  }, {
    threshold: 0.01
  });

  observer.observe(cartMain);
  observer.observe(cartSummary);

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    cartSummary.scrollIntoView({behavior: 'smooth', block: 'start'});
  });
}

/**
 * Pola telefonu:
 * - input[name="phone"]
 * - wymuszony '+' na początku
 * - trzymanie '+' przy wpisywaniu / wklejaniu
 * - poprawka przed submitem
 */
function initPhoneInputs() {
  const phones = document.querySelectorAll('input[name="phone"]');
  if (!phones.length) {
    return;
  }

  const ensureLeadingPlus = (el) => {
    const hadPlus = el.value.charAt(0) === '+';
    // zachowujemy resztę, ale zawsze z jednym '+' na początku
    el.value = el.value ? '+' + el.value.replace(/^\+*/, '') : '+';

    // w razie potrzeby można tu dorobić bardziej zaawansowaną obsługę caret-u
    // (pierwotny kod miał parametr keepCaret, ale realnie go nie używał)
  };

  phones.forEach((phone) => {
    // zabezpieczenie przed wielokrotnym init-em tego samego inputa
    if (phone.dataset.customEngineInit === '1') {
      return;
    }
    phone.dataset.customEngineInit = '1';

    phone.setAttribute('inputmode', 'tel');
    phone.setAttribute('autocomplete', 'tel');

    phone.addEventListener('focus', () => {
      if (!/^\+/.test(phone.value)) {
        ensureLeadingPlus(phone);
      }
    });

    // trzymaj + podczas pisania/wklejania
    phone.addEventListener('input', () => {
      ensureLeadingPlus(phone);
    });

    // na wszelki wypadek też przed submit
    if (phone.form) {
      // aby nie dokładać wielu submit listenerów na ten sam formularz:
      if (!phone.form.dataset.customPhoneSubmitInit) {
        phone.form.dataset.customPhoneSubmitInit = '1';

        phone.form.addEventListener('submit', () => {
          const formPhones = phone.form.querySelectorAll('input[name="phone"]');
          formPhones.forEach((fp) => ensureLeadingPlus(fp));
        });
      }
    }
  });
}

/**
 * Rejestracja: ładowanie stanów po wyborze kraju.
 *
 * Wymaga przekazania URL-a do API stanów:
 * - albo w data-atrybucie na select-cie:  <select name="addit__id_state" data-states-url="...">
 * - albo poprzez globalną zmienną: window.EBA_STATES_URL = '...';
 */
function initRegisterCountryStates() {
  const countrySel = document.querySelector('select[name="addit__id_country"]');
  const stateSel = document.querySelector('select[name="addit__id_state"]');

  const countrySel__Shipping = document.querySelector('select[name="addit__shipping_id_country"]');
  const stateSel__Shipping = document.querySelector('select[name="addit__shipping_id_state"]');

  if (!countrySel || !stateSel) {
    return;
  }

  if (!countrySel__Shipping || !stateSel__Shipping) {
    return;
  }

  // zabezpieczenie przed wielokrotnym init-em
  if (countrySel.dataset.customEngineInit === '1') {
    return;
  }
  countrySel.dataset.customEngineInit = '1';

  const STATES_URL =
    stateSel.dataset.statesUrl ||
    window.EBA_STATES_URL ||
    null;

  if (!STATES_URL) {
    // bez URL nie jesteśmy w stanie pobrać stanów
    console.warn('[custom-engine] Missing STATES_URL for country/state selects');
    return;
  }

  function toggleStateVisibility(stateSelEl, has) {
    const wrap = stateSelEl.closest('.cg-item') || stateSelEl.parentElement;
    // w oryginale było tylko disabled, display zakomentowany:
    // if (wrap) wrap.style.display = has ? '' : 'none';
    stateSelEl.disabled = !has;
  }

  function loadStates(countryId, stateSelEl, preselect) {
    if (!countryId) {
      stateSelEl.innerHTML = '<option value=""></option>';
      toggleStateVisibility(stateSelEl, false);
      return;
    }

    fetch(STATES_URL + '&id_country=' + encodeURIComponent(countryId), {
      credentials: 'same-origin',
    })
      .then((r) => r.json())
      .then((json) => {
        const states = json && json.states ? json.states : [];
        const html = ['<option value=""></option>'];

        for (let i = 0; i < states.length; i++) {
          const id = String(states[i].id);
          const name = states[i].name;
          const selected =
            preselect && String(preselect) === id ? ' selected' : '';
          html.push(
            '<option value="' + id + '"' + selected + '>' + name + '</option>'
          );
        }

        stateSelEl.innerHTML = html.join('');
        toggleStateVisibility(stateSelEl, states.length > 0);
      })
      .catch(() => {
        stateSelEl.innerHTML = '<option value=""></option>';
        toggleStateVisibility(stateSelEl, false);
      });
  }

  // pierwszy load: aktualne wartości selectów (jak w oryginale)
  loadStates(countrySel.value, stateSel, stateSel.value);

  // reaguj na zmianę kraju
  countrySel.addEventListener('change', function () {
    loadStates(this.value, stateSel, null);
  });
  countrySel__Shipping.addEventListener('change', function () {
    loadStates(this.value, stateSel__Shipping, null);
  });
}

const SAP_STOCK_SELECTOR = '.js-sap-stock';
let sapStockObserverStarted = false;

function normalizeSapWarehouseCode(value) {
  return String(value || '').trim();
}

function normalizeSapWarehouseName(value) {
  return String(value || '').trim().toLowerCase();
}

function parseSapWarehouses(raw) {
  if (!raw) {
    return [];
  }

  let parsed;

  try {
    parsed = JSON.parse(raw);
  } catch (e) {
    return [];
  }

  if (Array.isArray(parsed)) {
    return parsed
      .map((item) => ({
        code: String(item.code ?? item.warehouse_code ?? item.id ?? '').trim(),
        name: item.name || item.warehouse || '',
        quantity: parseInt(item.quantity ?? item.qty, 10) || 0,
        on_order: parseInt(item.on_order ?? item.onOrder ?? item.onorder ?? 0, 10) || 0,
      }))
      .filter((item) => item.code !== '' || item.name !== '');
  }

  if (parsed && typeof parsed === 'object') {
    return Object.keys(parsed).map((code) => {
      const row = parsed[code] || {};

      return {
        code: String(code).trim(),
        name: row.name || row.warehouse || '',
        quantity: parseInt(row.quantity ?? row.qty, 10) || 0,
        on_order: parseInt(row.on_order ?? row.onOrder ?? row.onorder ?? 0, 10) || 0,
      };
    });
  }

  return [];
}

function renderSapStockTotal(root, total) {
  const totalNode = root.querySelector('.js-sap-stock-total');
  if (!totalNode) {
    return;
  }

  const inStockLabel = root.dataset.labelInStock || 'In Stock';
  const outOfStockLabel = root.dataset.labelOutOfStock || 'Out of stock';

  totalNode.textContent = total > 0
    ? `${total} ${inStockLabel}`
    : outOfStockLabel;
}

function updateSapWarehouseRow(rowNode, data) {
  const quantityNode = rowNode.querySelector('.js-sap-stock-quantity');
  if (quantityNode) {
    quantityNode.textContent = String(data.quantity);
  }

  const onOrderNode = rowNode.querySelector('.js-sap-stock-on-order');
  if (onOrderNode) {
    onOrderNode.textContent = String(data.on_order);
  }

  const onOrderLine = rowNode.querySelector('.js-sap-stock-on-order-line');
  if (onOrderLine) {
    onOrderLine.hidden = data.on_order <= 0;
  }
}

function renderSapStockWarehouses(root, warehouses) {
  if (!warehouses.length) {
    return;
  }

  const rowNodes = root.querySelectorAll('.js-sap-stock-warehouse');
  if (!rowNodes.length) {
    return;
  }

  const rowsByCode = new Map();
  const rowsByName = new Map();

  rowNodes.forEach((rowNode) => {
    const code = normalizeSapWarehouseCode(
      rowNode.getAttribute('data-sap-warehouse-code')
    );
    const name = normalizeSapWarehouseName(
      rowNode.getAttribute('data-sap-warehouse-name')
    );

    if (code) {
      rowsByCode.set(code, rowNode);
    }

    if (name) {
      rowsByName.set(name, rowNode);
    }
  });

  warehouses.forEach((warehouse) => {
    const codeKey = normalizeSapWarehouseCode(warehouse.code);
    const nameKey = normalizeSapWarehouseName(warehouse.name);

    const rowNode = (
      (codeKey && rowsByCode.get(codeKey))
      || (nameKey && rowsByName.get(nameKey))
    );

    if (!rowNode) {
      return;
    }

    updateSapWarehouseRow(rowNode, warehouse);
  });
}

function applySapLiveData(root) {
  if (!(root instanceof Element)) {
    return;
  }

  const totalRaw = root.getAttribute('data-sap-live-total') || '';
  const warehousesRaw = root.getAttribute('data-sap-live-warehouses') || '';
  const warehouses = parseSapWarehouses(warehousesRaw);

  if (!warehouses.length && totalRaw === '') {
    return;
  }

  const total = totalRaw !== ''
    ? parseInt(totalRaw, 10) || 0
    : warehouses.reduce((sum, row) => sum + row.quantity, 0);

  renderSapStockTotal(root, total);

  if (warehouses.length) {
    renderSapStockWarehouses(root, warehouses);
  }
}

function processAllSapStock(scope = document) {
  scope.querySelectorAll(SAP_STOCK_SELECTOR).forEach(applySapLiveData);
}

function startSapStockObserver() {
  if (sapStockObserverStarted) {
    return;
  }

  sapStockObserverStarted = true;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.target instanceof Element) {
        if (
          mutation.attributeName === 'data-sap-live-total' ||
          mutation.attributeName === 'data-sap-live-warehouses'
        ) {
          applySapLiveData(mutation.target);
        }
      }

      for (const node of mutation.addedNodes || []) {
        if (!(node instanceof Element)) {
          continue;
        }

        if (node.matches?.(SAP_STOCK_SELECTOR)) {
          applySapLiveData(node);
        }

        node.querySelectorAll?.(SAP_STOCK_SELECTOR).forEach(applySapLiveData);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-sap-live-total', 'data-sap-live-warehouses'],
  });
}

function initSapStock() {
  processAllSapStock(document);
  startSapStockObserver();
}
